// extracted by mini-css-extract-plugin
export default {"unsubscribe_page":"NewsletterPage_unsubscribe_page__17Hz2","unsubscribe_card":"NewsletterPage_unsubscribe_card__kVaD6","form_row":"NewsletterPage_form_row__t5p4D"};